import React, { useState } from 'react';
import axiosInstance from '../request';
import { URL } from '../api';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const AddProduct = () => {
  const [formData, setFormData] = useState({
    productName: '',
    interestRate: '',
    interestRateType: 1,
    processFee: '',
    platformCharge: '',
    collectionCharge: '',
    convienceCharge:'',
    mapping:'',
    loanAmount: '',
    tenureInDays: '',
    repaymentType: 1,
    numberOfEmi: '',
    productType: ''
    

  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post(URL.PRODUCT_CREATE, formData);

      // ✅ Show success toast
      toast.success("Product created successfully!");

      // ✅ Reset form so user can add another one
      setFormData({
        productName: '',
        interestRate: '',
        interestRateType: 1,
        processFee: '',
         platformCharge: '',
        collectionCharge: '',
        convienceCharge:'',
        mapping:'',
        loanAmount: '',
        tenureInDays: '',
        repaymentType: 1,
        numberOfEmi: '',
        productType: ''
       
      });

    } catch (error) {
      console.error('Error creating product:', error);
      toast.error("Failed to create product");
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-3">Add New Product</h3>
      <form onSubmit={handleSubmit} className="border p-3 rounded">
        {/* 🔽 Your form fields remain unchanged */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Product Name</label>
            <input
              type="text"
              name="productName"
              value={formData.productName}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Interest Rate (%)</label>
            <input
              type="number"
              name="interestRate"
              value={formData.interestRate}
              onChange={handleChange}
              className="form-control"
              step="0.01"
              required
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Interest Rate Type</label>
            <select
              name="interestRateType"
              value={formData.interestRateType}
              onChange={handleChange}
              className="form-select"
            >
              <option value={1}>Flat</option>
              <option value={2}>Reducing</option>
            </select>
          </div>
        </div>

     <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Processing Fee</label>
            <input
              type="number"
              name="processFee"
              value={formData.processFee}
              onChange={handleChange}
              className="form-control"
              step="0.01"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Platform Charge (%)</label>
            <input
              type="number"
              name="platformCharge"
              value={formData.platformCharge}
              onChange={handleChange}
              className="form-control"
              step="0.01"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Collection Charge (%)</label>
            <input
              type="number"
              name="collectionCharge"
              value={formData.collectionCharge}
              onChange={handleChange}
              className="form-control"
              step="0.01"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Convience Charge (%)</label>
            <input
              type="number"
              name="convienceCharge"
              value={formData.convienceCharge}
              onChange={handleChange}
              className="form-control"
              step="0.01"
            />
          </div>
          
          <div className="col-md-3">
            <label className="form-label"> Product Mapping</label>
            <select
              name="mapping"
              value={formData.mapping}
              onChange={handleChange}
              className="form-select"
            >
              <option value={1}>Live Product</option>
              <option value={2}>Agent Product</option>
            </select>
          </div>
        

          <div className="col-md-4">
            <label className="form-label">Loan Amount</label>
            <input
              type="number"
              name="loanAmount"
              value={formData.loanAmount}
              onChange={handleChange}
              className="form-control"
              step="0.01"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Tenure (Days)</label>
            <input
              type="number"
              name="tenureInDays"
              value={formData.tenureInDays}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Repayment Type</label>
            <select
              name="repaymentType"
              value={formData.repaymentType}
              onChange={handleChange}
              className="form-select"
            >
              <option value={1}>Daily</option>
              <option value={2}>Weekly</option>
              <option value={3}>Monthly</option>
              <option value={4}>Bullet</option>
              <option value={5}>Quarterly</option>
              <option value={6}>BI Weekly</option>
              <option value={7}>Yearly</option>
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label">No. of EMI</label>
            <input
              type="number"
              name="numberOfEmi"
              value={formData.numberOfEmi}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Product Type</label>
            <input
              type="number"
              name="productType"
              value={formData.productType}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <button type="submit" className="btn btn-primary">
            Save Product
          </button>
        </div>
      </form>

      {/* ✅ Toast container */}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default AddProduct;
